/**
 * Prevent user from opening multiple dropdown menus.
 * @returns {*|jQuery}
 */
export const enablePreventMultipleDropdownMenus = () => jQuery('#navbarSupportedContent .toggle-menu-menu').click(e => {
    const menuIsAlreadyCollapsing = jQuery('.collapsing').length;
    if (menuIsAlreadyCollapsing) {
        e.stopPropagation();
        return;
    }
    jQuery('.collapse.mega-menu').collapse('hide');
});

/**
 * Font switcher
 * @param selectors
 * @param clickedSelector
 * @param sizeToSet
 * @param textDecorationClass
 */
const fontSizeSwitchHandler = (selectors, clickedSelector, sizeToSet, textDecorationClass) => {
    const fontSizeCss = {
        property: 'font-size',
        small: '100%',
        medium: '120%',
        large: '140%',
    };
    const mainNavCss = {
        property: 'top',
        small: '2.8em',
        medium: '2.7em',
        large: '2.6em',
    };
    const searchNavCss = {
        property: 'top',
        small: '8.4em',
        medium: '7.4em',
        large: '6.6em',
    };

    jQuery(`${selectors.fontSizeSmall}, ${selectors.fontSizeMedium}, ${selectors.fontSizeLarge}`).removeClass(textDecorationClass);
    jQuery(selectors.body).css(fontSizeCss.property, fontSizeCss[sizeToSet]);
    jQuery(selectors.mainNav).css(mainNavCss.property, mainNavCss[sizeToSet]);
    jQuery(selectors.searchNav).css(searchNavCss.property, searchNavCss[sizeToSet]);
    jQuery(clickedSelector).addClass(textDecorationClass);
};

let currentFontSizeIndex = 1;
export const enableFontSizeSwitcher = () => {
    const selectors = {
        rootElement: 'html',
        increaseFontSize: '#increase-font-size',
    };

    const fontSizeProperty = 'font-size';
    const fontSizes = ['16px', '18px', '20px'];

    const changeFontSize = () => {
        // Reset font size if it is already increased to the max.
        if (currentFontSizeIndex >= fontSizes.length) {
            jQuery(selectors.rootElement).css(fontSizeProperty, fontSizes[0]);
            currentFontSizeIndex = 1;
            return;
        }
        jQuery(selectors.rootElement).css(fontSizeProperty, fontSizes[currentFontSizeIndex]);
        currentFontSizeIndex++;
    }

    jQuery(selectors.increaseFontSize).click(() => {
        changeFontSize();
    });
    jQuery(selectors.increaseFontSize).keypress((e) => {
        e.keyCode === 13 && changeFontSize();
    });
};

/**
 * Trigger read speaker on enter if element is focused.
 * @returns {*|jQuery}
 */
export const enableReadSpeakerTriggerOnEnter = () => jQuery('#readspeaker_button1').keypress(e => {
    e.keyCode === 13 && jQuery('#start-readspeaker').trigger("click");
});
